import { FC, ReactNode } from "react";
import { NavLinkProps } from "react-router-dom";

import { StyledHeaderLink } from "./Styled";

interface HeaderNavLinkProps extends NavLinkProps {
    children: ReactNode;
}

export const HeaderNavLink: FC<HeaderNavLinkProps> = ({
    children,
    ...rest
}) => {
    return <StyledHeaderLink {...rest}>{children}</StyledHeaderLink>;
};
